/**
 * Session Provider Component
 * Handles automatic session restoration and management
 */

import React, { ReactNode } from 'react';
import { useSessionManagement } from '../../hooks/useSessionManagement';
import { useAppSelector } from '../../store/hooks';

interface SessionProviderProps {
  children: ReactNode;
}

const SessionProvider: React.FC<SessionProviderProps> = ({ children }) => {
  const { sessionChecked } = useAppSelector((state) => state.auth);

  useSessionManagement({
    autoCheckSession: true,
    autoRefresh: true,
    activityMonitoring: true,
    onSessionExpired: () => {
      // Session expiration is handled by ProtectedRoute
    },
    onTokenRefreshed: () => {
      // Token refreshed successfully
    },
  });


  // Show loading spinner while checking session
  if (!sessionChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-mirsal-green mx-auto"></div>
          <p className="mt-4 text-gray-600">Checking session...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default SessionProvider;
